export default class UpdateSelfInfoModel {
  nickName?: string;

  phoneNo?: string;

  phonePrefix = '86';

  creationDate?: Date;

  contacts?: string;

  address?: string;
}
